import { routes } from '@/shared/routes';
import { ModelName } from '@/shared/types/model';

import { POST } from '@/front/fetch';
import { confirmModal } from '@/front/modal';

export const archive = async (button: HTMLAnchorElement | HTMLButtonElement, archive: boolean) => {
  const modelName = button.dataset.model as ModelName | undefined;
  const id = button.dataset.value;

  if (
    await confirmModal(
      `Are you sure you want to ${archive ? 'archive' : 'unarchive'} this record?`,
      archive ? 'Archive' : 'Unarchive',
      archive ? 'warning' : 'primary',
    )
  ) {
    if (modelName && id) {
      let url = '';

      if (modelName === 'Organisation') {
        url = archive ? routes.organisations.archive({ id }) : routes.organisations.unarchive({ id });
      } else if (modelName === 'Individual') {
        url = archive ? routes.individuals.archive({ id }) : routes.individuals.unarchive({ id });
      } else if (modelName === 'User') {
        url = archive ? routes.members.archive({ id }) : routes.members.unarchive({ id });
      } else if (modelName === 'Service') {
        url = archive ? routes.services.archive({ id }) : routes.services.unarchive({ id });
      }

      if (!url) return;

      const res = await POST(url);

      if (!res.ok) return;

      location.reload();
    }
  }
};
